export enum UserRole {
  Admin = "Admin",
  Bueroleitung = "Bueroleitung",
  BueroMA = "BueroMA",
}
